import { Injectable, signal } from '@angular/core';
import { Movie } from '@usheru-hff/shared/domain';

@Injectable()
export class ShowtimesStoreService {
  movie = signal<Movie | undefined>(undefined);
  inlineMap = signal<boolean>(false);
  constructor() {}

  setMovie(movie: Movie) {
    this.movie.set(movie);
  }

  setInlineMap(inlineMap: boolean) {
    this.inlineMap.set(inlineMap);
  }
}
